import { Popover } from 'antd';
import { IconAvatarArrowDown } from '@/assets/static/icons';
import '../profile-dropdown.style.css';
import { ProfileContent } from './profile-content';
import { useProfile } from '../hooks/use-profile-dropdown';
import { AppAvatar } from '@components/app-avatar';

export function ProfileDropdownContainer() {
  const { userName, profileUrl } = useProfile();
  return (
    <div>
      <Popover
        content={<ProfileContent />}
        destroyOnHidden
        trigger="click"
        placement="bottomRight"
        arrow={false}
        className="p-0"
        rootClassName="logout__popover"
      >
        <div className="cursor-pointer relative flex">
          <AppAvatar src={profileUrl} className="size-9! border-gray-500!" name={userName} />
          <IconAvatarArrowDown className="absolute top-[22px] right-0" />
        </div>
      </Popover>
    </div>
  );
}
